import Router from './util/Router'
import common from './routes/common'
import pageTemplateShows from './routes/shows'
import singleShow from './routes/single-show'
import singleClass from './routes/single-class'
import pageTemplateCalendar from './routes/calendar'
import pageTemplateGroupSales from './routes/group-sales'
import pageTemplateHomepage from './routes/homepage'

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
	common,
	pageTemplateShows,
	singleShow,
	singleClass,
	pageTemplateCalendar,
	pageTemplateGroupSales,
	pageTemplateHomepage
})

/** Load Events */
routes.loadEvents()